import React from "react";
import { Page } from "../library";
import CoursesData from "../courses/CoursesData";

export default function MyCourses(props) {
  return (
    <Page title="Meus Cursos">
      <CoursesData
        justOwned
        emptyMessage="Nenhum curso encontrado"
        emptyDescription="Explore a loja e comece a aprender agora mesmo."
        emptyLinkTo="/store"
        emptyLinkText="Ir para a Loja"
        {...props}
      />
    </Page>
  );
}
